import React from 'react';
import { Age, Code } from './LivePage';
import PagedWorkloadPage from './PagedWorkloadPage';

export default function Jobs() {
  return (
    <PagedWorkloadPage
      title="Jobs" kind="Job" resource="jobs" label="jobs"
      deletable
      cols={['Name', 'Namespace', 'Completions', 'Succeeded', 'Failed', 'Active', 'Age']}
      renderRow={j => [
        <td key="n"><Code>{j.name}</Code></td>,
        <td key="ns" style={{ color: 'var(--ink-2)', fontSize: 13 }}>{j.namespace}</td>,
        <td key="c">{j.completions}</td>,
        <td key="s" style={{ color: 'var(--color-success-500)', fontWeight: 600 }}>{j.succeeded}</td>,
        <td key="f" style={{ color: j.failed > 0 ? 'var(--color-danger-500)' : 'var(--muted)' }}>{j.failed}</td>,
        <td key="ac">{j.active}</td>,
        <td key="a"><Age ts={j.created_at} /></td>,
      ]}
    />
  );
}
